import type { PaperWidthMm } from './types';

export const DEFAULT_PAPER_WIDTH_MM: PaperWidthMm = 80;

/** Font A columns for the common 58mm and 80mm thermal rolls. */
export const lineCharsForPaperWidth = (paperWidth: number): number =>
  paperWidth === 58 ? 32 : 48;

export const normalizePaperWidth = (paperWidth?: number): PaperWidthMm =>
  paperWidth === 58 ? 58 : DEFAULT_PAPER_WIDTH_MM;
